<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="top-bar">
  <h3 class="draggable">
    {{'dashboard.endpoint-location.title' | translate}}
  </h3>
  <div class="select-time-wrapper">
    <mat-select [value]="filterValue$ | async" (valueChange)="filterValue$.next($event)" [panelWidth]="null">
      <mat-option value="two_weeks">{{'DASH_DATA_2WK' | translate}}</mat-option>
      <mat-option value="connected">{{'DASH_END_CONNECTED' | translate}}</mat-option>
      <mat-option value="all">{{'ALL' | translate}}</mat-option>
    </mat-select>
  </div>
</div>

<div class="map" leaflet
     [leafletOptions]="mapOptions$ | async"
     [leafletMarkerCluster]="(markerClusterData$ | async) || []"
     [leafletMarkerClusterOptions]="markerClusterOptions">
</div>
